import Vue from 'vue'
import Vuex, { ActionContext } from 'vuex'
import ajax from '../lib/ajax'
Vue.use(Vuex)
import app from './modules/app'
import session from './modules/session'
import permission from './modules/permission'
// import account from './modules/account'
// import user from './modules/user'
// import role from './modules/role'
// import tenant from './modules/tenant'
interface State {
	username: string
	activeMenu: string
}
const store = new Vuex.Store<State>({
	state: {
		//
		username: 'jttms',
		activeMenu: '/main'
	},
	mutations: {
		//
		login(state: State, payload: any) {
			state.username = payload.username
		},
		setActiveMenu(state: State, payload: string) {
			state.activeMenu = payload
		}
	},
	actions: {
		async login(content: ActionContext<State, any>, payload: any) {
			let rep = await ajax.post('/api/TokenAuth/Authenticate', payload.data)
			let tokenExpireDate = payload.data.rememberMe ? (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) : undefined
			// Util.abp.auth.setToken(rep.data.result.accessToken,tokenExpireDate)
			// Util.abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName,rep.data.result.encryptedAccessToken,tokenExpireDate,Util.abp.appPath)
		}
	},
	modules: {
		app,
		session,
		permission,
		// account,
		// user,
		// role,
		// tenant,
	}
})

export default store
